module.exports = __webpack_public_path__ + "static/media/Impreza-GD-WRX-STi.75fd5e2f.webp";